import { resolveCrossAppHref } from '@naumu/shared/routes/origins';

/**
 * Which of the two deployables this bundle is running in.
 *
 * `@naumu/platform-client` is imported by BOTH `apps/marketing` and
 * `apps/web`, and the landing<->platform handoff it owns has to know which
 * side it is standing on: entering a space from marketing crosses an origin in
 * local dev (`:3002` -> `:3000`), while the same call from web is same-origin.
 *
 * Why a module-level setter and not a React context: the only consumer is
 * `goToSpace` inside `useGuestProvisioning`, a fire-once imperative navigation.
 * A context would mean wrapping BOTH apps' trees in yet another provider and
 * threading a value through re-renders for a value that is constant for the
 * lifetime of the bundle. One call at import time in each app's providers
 * module is the smallest change that cannot get out of sync.
 *
 * Default is `'platform'` on purpose: it makes `resolvePlatformHref` a no-op,
 * which is both the deployed behaviour (one origin) and the pre-existing
 * behaviour, so a missing call degrades to today rather than to a wrong origin.
 *
 * Call sites:
 *  - `apps/marketing/app/providers-minimal.tsx` -> `{ app: 'marketing' }`
 *  - `apps/web/app/providers.tsx`           -> `{ app: 'platform' }`
 */
let currentApp: 'marketing' | 'platform' = 'platform';

export const configurePlatformClient = ({
	app,
}: {
	app: 'marketing' | 'platform';
}): void => {
	currentApp = app;
};

/** The configured app. Exported for tests and for debugging a bad handoff. */
export const getPlatformClientApp = (): 'marketing' | 'platform' => currentApp;

/**
 * Resolve an href against the app this bundle runs in - the platform-client
 * flavour of `resolveCrossAppHref`, so call sites never repeat the `from`.
 */
export const resolvePlatformHref = (href: string): string =>
	resolveCrossAppHref(href, currentApp);
